import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { HistoricalMovementType } from '../historical-movement-type';

export class HistoricalMovementTypesBuilder {

  static fromJson(json) {
    return (json)
      ? new HistoricalMovementType(
        parseNumber(json.code),
        json.translate,
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(HistoricalMovementTypesBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/historical-movement-types.builder.ts